function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Embed from '../blots/embed.js';
import Emitter from './emitter.js';
var Composition = /*#__PURE__*/function () {
  function Composition(scroll, emitter) {
    _classCallCheck(this, Composition);
    _defineProperty(this, "isComposing", false);
    this.scroll = scroll;
    this.emitter = emitter;
    this.setupListeners();
  }
  return _createClass(Composition, [{
    key: "setupListeners",
    value: function setupListeners() {
      var _this = this;
      this.scroll.domNode.addEventListener('compositionstart', function (event) {
        if (!_this.isComposing) {
          _this.handleCompositionStart(event);
        }
      });
      this.scroll.domNode.addEventListener('compositionend', function (event) {
        if (_this.isComposing) {
          // Webkit makes DOM changes after compositionend, so we use microtask to
          // ensure the order.
          // https://bugs.webkit.org/show_bug.cgi?id=31902
          queueMicrotask(function () {
            _this.handleCompositionEnd(event);
          });
        }
      });
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart(event) {
      var blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
      if (blot && !(blot instanceof Embed)) {
        this.emitter.emit(Emitter.events.COMPOSITION_BEFORE_START, event);
        this.scroll.batchStart();
        this.emitter.emit(Emitter.events.COMPOSITION_START, event);
        this.isComposing = true;
      }
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd(event) {
      this.emitter.emit(Emitter.events.COMPOSITION_BEFORE_END, event);
      this.scroll.batchEnd();
      this.emitter.emit(Emitter.events.COMPOSITION_END, event);
      this.isComposing = false;
    }
  }]);
}();
export default Composition;